import React, { useContext } from 'react'
import { OffreModel } from '../types/OffreModel'
import { FormattedMessage } from 'react-intl'
import { ResponsiveContext } from '../../../utils/context/ResponsiveContext'
import styles from '../../../styles'
import { WHITE } from '../../../theme'
import { makeStyles } from 'tss-react/mui'
import { Grid } from '@mui/material'
import { getLotCompleteCategoryKey } from '../../../enums/lot/lotCompleteTypesEnum'

const useStyles = makeStyles<{ isLargeScreen: boolean }>()((theme, { isLargeScreen }) => ({
	...styles(theme),
	enTeteContainer: {
		backgroundColor: WHITE
	},
	infoContainer: {
		marginLeft: isLargeScreen ? 60 : 30,
		marginRight: isLargeScreen ? 60 : 30,
		marginTop: isLargeScreen ? 25 : 0,
		justifyContent: 'space-between'
	},
	titleContainer: {
		display: 'flex',
		flexDirection: 'column',
		margin: 0
	},
	surTitre: {
		...styles(theme).title0,
		fontSize: isLargeScreen ? 65 : 38,
		marginBottom: isLargeScreen ? 12 : 15,
		lineHeight: isLargeScreen ? '63px' : '48px',

		'&:first-letter': {
			textTransform: 'capitalize'
		}
	},
	sousTitre: {
		fontSize: isLargeScreen ? 18 : 16,
		fontWeight: 600,
		color: theme.palette.primary.main,
		marginTop: isLargeScreen ? 8 : 0,
		marginBottom: isLargeScreen ? 0 : 34
	},
	buttonStyle: {
		backgroundColor: '#eff3f5 !important',
		borderRadius: 25,
		padding: 0,
		minWidth: 50,
		height: 50,
		marginLeft: 8
	}
}))

interface AcceptingProps {
	offre: OffreModel
}

type EnteteProps = AcceptingProps

const Entete: React.FC<EnteteProps> = (
	{
		offre
	}
) => {
	const { isLargeScreen } = useContext(ResponsiveContext)
	const { classes } = useStyles({ isLargeScreen })

	return (
		<Grid container item xs={12} className={classes.enTeteContainer}>
			<Grid container item md={12} className={classes.infoContainer}>
				{/* Conteneur du titre et du sous-titre */}
				<Grid item xs={12}>
					<h1 className={classes.titleContainer}>
						<span className={classes.surTitre}>
							<>
								<FormattedMessage
									id={`lot.type.${offre.type}`}
									defaultMessage="Appartement"
									description="Type du bien"
								/> {` `}
							</>

							{
								offre.genre && (
									<FormattedMessage
										id={`lot.details.completeCategory.${getLotCompleteCategoryKey(Number(offre.genre))}`}
										defaultMessage="2 pièces"
										description="Complete category label"
									/>
								)
							}
						</span>

						<span className={classes.sousTitre}>
							YouFirst Residence {offre.residence.intituleCRM}
						</span>
					</h1>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default Entete